<hb-base-widget
  [dashboardWidget]="dashboardWidget"
  [title]="title"
  [sortable]="sortable"
  [showActions]="showActions"
  [showDataOption]="true"
  [widgetTableData]="dashboardWidget?.widget?.data?.TableData"
  [hideCog]="hideCog"
  [hideDragAndDrop]="hideDragAndDrop"
  [hideTitleEdit]="hideTitleEdit"
>
  <div class="widget-chart-container px-2">
    <canvas class="chart" [id]="canvasId"></canvas>
  </div>
</hb-base-widget>
